import { Translate } from '@change-corgi/core/react/i18n';
import { SocialButton } from '@change-corgi/design-system-legacy/components/social';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { ResponsiveBox } from 'src/app/pages/petitionGamma/details/shared/components';
import { AfterMediaWaypoint } from 'src/app/pages/petitionGamma/details/shared/waypoints';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { usePetitionDetails } from '../../hooks/petitionDetails/petitionDetails';
import { usePhoto } from '../../hooks/photo';
import { useFirstMovement } from '../../hooks/useFirstMovement';
import { MediaContainer } from '../Media';
import { MovementContainer } from '../Movement';

import { usePetitionHeadingMobile } from './hooks/usePetitionHeadingMobile';

// TODO: This should be renamed because it handles both small and large viewport heading content.
export function HeadingContainerMobile(): JSX.Element {
	const details = usePetitionDetails();
	const photo = usePhoto();
	const firstMovement = useFirstMovement();
	const isMobile = useIsMobile();
	const { actions } = usePetitionHeadingMobile();

	return (
		<Box data-testid="heading-container-mobile" sx={{ position: 'relative' }}>
			{isMobile && photo && (
				<SocialButton
					channel="mobileNativeShare"
					iconOnly
					size="large"
					onClick={actions.handleShare}
					data-qa="native-share-button"
					data-testid="native-share-button"
					sx={{
						width: '50px',
						height: '50px',
						minWidth: '50px !important',
						minHeight: '50px !important',
						position: 'absolute',
						top: '20px',
						right: '16px',
						boxShadow: '0px 2px 12px 0px var(--shadow-primary-default-default, rgba(58, 41, 62, 0.25))',
						border: '1px solid var(--stroke-secondary-default, #CFCBD0)',
						borderRadius: '50% !important',
						zIndex: 1,
					}}
				>
					<Translate value="corgi.petition_gamma.share.mobile_native_share" />
				</SocialButton>
			)}

			<Box px={0} pt={[0, 8]} pb={[null, 8]}>
				{!!photo && <MediaContainer key={details.id} photo={photo} />}
				<AfterMediaWaypoint />
			</Box>

			<ResponsiveBox viewportSize="small">
				<Box
					pt={[16, 40]}
					px={[16, 0]}
					mt={[photo ? -45 : 0, 0]}
					mb={[16, 0]}
					mx={16}
					sx={{
						position: 'relative',
						background: 'white',
						borderRadius: '10px',
					}}
				>
					<Heading
						as="h1"
						size="h2"
						pt={0}
						breakWord
						data-qa="petition-title"
						sx={{
							textAlign: ['center'],
							lineHeight: '44px',
							fontSize: '30px',
						}}
					>
						{details.ask}
					</Heading>
				</Box>
			</ResponsiveBox>

			{firstMovement && (
				<Box mb={[16, 8]} px={[16, 0]}>
					<MovementContainer movement={firstMovement} alwaysExpanded={!photo} />
				</Box>
			)}
		</Box>
	);
}
